"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceMapper = insuranceMapper;
exports.patientInformationMapper = patientInformationMapper;
exports.recentMRNsMapper = recentMRNsMapper;
exports.labDetailsMapper = labDetailsMapper;
exports.labRequisitionsMapper = labRequisitionsMapper;
exports.physicianMapper = physicianMapper;
exports.diagnosisMapper = diagnosisMapper;
function insuranceMapper(insuranceInformation) {
    if (insuranceInformation) {
        if (insuranceInformation.insuranceType === "Medicare") {
            return {
                policyType: insuranceInformation.insuranceType,
                mbi: insuranceInformation.mbi,
                policyProvider: insuranceInformation.policyProvider,
            };
        }
        else if (insuranceInformation.insuranceType === "Managed Medicare") {
            return {
                policyType: insuranceInformation.insuranceType,
                policyNumber: insuranceInformation.policyNumber,
                policyProvider: insuranceInformation.policyProvider,
            };
        }
    }
}
function patientInformationMapper(patientInformation) {
    return Object.assign(Object.assign({}, patientInformation), { insurance: insuranceMapper(patientInformation === null || patientInformation === void 0 ? void 0 : patientInformation.insurance), caregiver: patientInformation === null || patientInformation === void 0 ? void 0 : patientInformation.caregiver, pharmacy: patientInformation === null || patientInformation === void 0 ? void 0 : patientInformation.pharmacy });
}
function recentMRNsMapper(patients) {
    return patients.map(patient => {
        var _a, _b, _c, _d;
        return ({
            mrn: patient.mrn,
            firstName: (_a = patient.firstName) !== null && _a !== void 0 ? _a : "",
            lastName: (_b = patient.lastName) !== null && _b !== void 0 ? _b : "",
            dob: (_c = patient.dateOfBirth) !== null && _c !== void 0 ? _c : "",
            startOfCare: (_d = patient.startOfCare) !== null && _d !== void 0 ? _d : "",
        });
    });
}
function labDetailsMapper(labDetails) {
    return Object.assign({}, labDetails);
}
function labRequisitionsMapper(labRequisitions) {
    return labRequisitions.map(r => (Object.assign({}, r)));
}
function physicianMapper(physicianInformation) {
    return {
        physicianName: physicianInformation === null || physicianInformation === void 0 ? void 0 : physicianInformation.name,
        physicianNPI: physicianInformation === null || physicianInformation === void 0 ? void 0 : physicianInformation.npi,
        physicianPhone: physicianInformation === null || physicianInformation === void 0 ? void 0 : physicianInformation.phone,
    };
}
function diagnosisMapper(diagnosisInformation) {
    return diagnosisInformation;
}
